import MXDescriptionToggle from "@rf-l1/MXDescriptionToggle";

interface IVariantDescriptionProps {
  text: string;
  show: string;
}

const VariantDescription: React.FC<IVariantDescriptionProps> = props => {
  return <MXDescriptionToggle text={props.text} />;
};

export default VariantDescription;
